import { authConfigurationValuesTypes } from "../../types";

export const authDefaultValues: authConfigurationValuesTypes = {
    otpDisclaimer: {
        "name": "otpDisclaimer",
        "type": "list",
        "value": [],
        "docUrl": "",
        "description": "",
        "possibleVals": [
          "string"
        ]
    },
    phoneNumberMaximumLength: {
        "name": "phoneNumberMaximumLength",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "",
        "possibleVals": [
          "string"
        ]
    },
    phoneNumberMinimumLength: {
        "name": "phoneNumberMinimumLength",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "",
        "possibleVals": [
          "string"
        ]
    },
    outletLoginHintText: {
        "name": "outletLoginHintText",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "",
        "possibleVals": [
          "string"
        ]
    },
    phoneLoginHintText: {
        "name": "phoneLoginHintText",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "",
        "possibleVals": [
          "string"
        ]
    },

    logoutMessage: {
        "name": "logoutMessage",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "",
        "possibleVals": [
          "string"
        ]
    },
    otpTimer: {
        "name": "otpTimer",
        "type": "string",
        "value": "",
        "docUrl": "",
        "description": "",
        "possibleVals": [
          "string"
        ]
    },

    loginType:{
        "name": "loginType",
        "type": "string",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "login type",
        "possibleVals": [
        "password",
        "otp",
        "otpAndPassword"
        ]
    },
    otpProvider:{
        "name": "otpProvider",
        "type": "string",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "different req bodies are made for vonage and others while sending otp",
        "possibleVals": [
        "vonage",
        "other"
        ]
    },
    otpType:{
        "name": "otpType",
        "type": "string",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "otp type",
        "possibleVals": [
            "string"
        ]
    },
    subheading:{
        "name": "subheading",
        "type": "string",
        "value": "",
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Sub Heading To Be Displayed in App",
        "possibleVals": []
    },
    instantRegistration:{
        "name": "instantRegistration",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Sub Heading To Be Displayed in App",
        "possibleVals": [false,true]
    },
    termsChecked:{
        "name": "termsChecked",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Sub Heading To Be Displayed in App",
        "possibleVals": [false,true]
    },
    deviceUID:{
        "name": "deviceUID",
        "type": "boolean",
        "value": false,
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Sub Heading To Be Displayed in App",
        "possibleVals": [false,true]
    },
    loginBanners: {
        "name": "loginBanners",
        "type": "list",
        "value": ["","",""],
        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
        "description": "Login Banners to display in app",
        "possibleVals": []
    }
    
}